import { compose, getContext, withProps } from 'recompose'
import { connect } from 'react-redux'
import { CONTEXT } from '../../../shared/Wizard/WizardProvider'
import { selectClientHasHomes } from '../../../../store/selectors/client'

const NewHomeStepContainer = compose(
  getContext(CONTEXT),
  connect(state => ({
    hasHomes: selectClientHasHomes(state),
  })),
  withProps(({ onAddress, onPurchaseDate, goForward }) => ({
    onAddress: result => {
      onAddress(result)
      goForward()
    },
    onPurchaseDate: () => {
      onPurchaseDate()
      goForward()
    },
  }))
)

export default NewHomeStepContainer
